// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Drawer, { DrawerPresentationProps } from "@insite/mobius/Drawer";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import { injectCss } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import setOnePageCheckoutProductListOverlayIsOpen from "@store/Framework/Store/Starter/Components/OnePageCheckoutProductListOverlay/Handlers/SetOnePageCheckoutProductListOverlayIsOpen";
import { useOnePageCheckoutProductListOverlay } from "@store/Framework/Store/Starter/Components/OnePageCheckoutProductListOverlay/OnePageCheckoutProductListOverlayHooks";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { useLocation } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import React, { FC, useEffect } from "react";
import styled, { css } from "styled-components";

export interface OnePageCheckoutProductListOverlayProps extends PageProps {}

export interface OnePageCheckoutProductListOverlayStyles {
    page?: MobiusPageProps;
    drawer?: DrawerPresentationProps;
    innerWrapper?: InjectableCss;
}

export const onePageCheckoutProductListOverlayStyles: OnePageCheckoutProductListOverlayStyles = {
    page: {
        as: "div",
        padding: 0,
    },
    drawer: {
        mergeCss: true,
        cssOverrides: {
            drawerBody: css`
                width: 100%;
                ${breakpoint("md")} {
                    width: ${pxToRem(850)};
                }
            `,
        },
    },
    innerWrapper: {
        css: css`
            padding: ${pxToRem(20)};
        `,
    },
};

const InnerWrapper = styled.div<{ isEdit?: boolean } & InjectableCss>`
    ${props => (props.isEdit ? "padding: 0;" : "")}
    ${injectCss}
`;

const styles = onePageCheckoutProductListOverlayStyles;

const OnePageCheckoutProductListOverlay: FC<OnePageCheckoutProductListOverlayProps> = ({
    id,
}: OnePageCheckoutProductListOverlayProps) => {
    const dispatch = useAppDispatch();
    const { isOpen } = useOnePageCheckoutProductListOverlay();
    const location = useLocation();
    const { isInShell, isCurrentPage, isEditing } = useShellContext();
    const isShell = isCurrentPage && isInShell;
    const isEdit = isShell && isEditing;

    const closeDrawer = () => {
        dispatch(setOnePageCheckoutProductListOverlayIsOpen({ isOpen: false }));
    };

    useEffect(() => {
        closeDrawer();
    }, [location.pathname]);

    return (
        <Page {...styles.page}>
            <Drawer
                {...styles.drawer}
                position="right"
                isOpen={isOpen || isShell}
                handleClose={closeDrawer}
                contentLabel="product list drawer"
            >
                <InnerWrapper isEdit={isEdit} {...styles.innerWrapper}>
                    <Zone contentId={id} zoneName="Content" />
                </InnerWrapper>
            </Drawer>
        </Page>
    );
};

const pageModule: PageModule = {
    component: OnePageCheckoutProductListOverlay,
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "Content",
    },
};

export default pageModule;
